import React from 'react';

//FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './SocialButton.css';

const SocialButton = (props) => {
    return (
        <a href={props.href} target="_blank" rel="noopener noreferrer" className="custom-btn-social" title={props.title}>
            <span>
                <FontAwesomeIcon icon={props.icon} />
            </span>
        </a>

    );
};

export default SocialButton;